module.exports = __webpack_public_path__ + "images/emoji/wine_glass.3785576507b2eae92d42.png";